import { Alert, Stack, TextField, Typography } from "@mui/material";

import { ErrorTypography } from "components/ErrorTypography";
import {
  MultiShipmentProjectQuoteFields,
  SingleShipmentQuoteFields,
} from "components/QuoteFields";

import type { OffPlatformBookingFormState } from "./types";

interface Props {
  shipment: ShipperCondensedShipment;
  formState: OffPlatformBookingFormState;
  onValueChanged: <T>(key: keyof OffPlatformBookingFormState, value: T) => void;
  onSubmit: VoidFunction;
  onPopulateShipmentRequirements: VoidFunction;
  error: UIError;
  loading: boolean;
}

export function MarkBookedOffPlatformForm(props: Props) {
  const {
    shipment,
    formState,
    onValueChanged,
    onSubmit,
    onPopulateShipmentRequirements,
    error,
    loading,
  } = props;

  const sharedFieldProps = {
    shipment,
    formState,
    onValueChanged,
    audience: "shipper" as const,
    onPopulateShipmentRequirements,
    loading,
    onSubmit,
    submitLabel: "Send to Support",
    messages: <ErrorTypography error={error} />,
  };

  return (
    <Stack spacing={2}>
      <Alert severity="info">
        Evotrux support will create the carrier and record the booking for you.
        The shipment stays active until they do.
      </Alert>

      <Typography variant="subtitle1">Who did you book with?</Typography>
      <TextField
        label="Carrier Email"
        value={formState.carrierEmail}
        onChange={(e) => onValueChanged<string>("carrierEmail", e.target.value)}
        sx={{ width: "100%" }}
      />
      <TextField
        label="Carrier Company Name"
        value={formState.carrierCompanyName}
        onChange={(e) =>
          onValueChanged<string>("carrierCompanyName", e.target.value)
        }
        sx={{ width: "100%" }}
      />
      <Typography variant="caption">
        Give us whichever you have: an email, a company name, or both.
      </Typography>

      <Typography variant="subtitle1">What did you agree to?</Typography>
      {shipment.info.type === "MULTI_SHIPMENT_PROJECT" ? (
        <MultiShipmentProjectQuoteFields {...sharedFieldProps} />
      ) : (
        <SingleShipmentQuoteFields {...sharedFieldProps} />
      )}
    </Stack>
  );
}
